import PropTypes from 'prop-types';
import defaultAriaProps from 'client/utils/constants/ariaPropTypes';
import styles from './Panel.module.scss';

const Panel = ({ title, message, ...props }) => {
    return (
        <div className="govuk-panel govuk-panel--confirmation" {...props}>
            <h1 className={['govuk-panel__title', styles.title].join(' ')}>
                {title}
            </h1>
            <div className={['govuk-panel__body', styles.message].join(' ')}>
                {message}
            </div>
        </div>);
};

Panel.propTypes = {
    ...defaultAriaProps,
    title: PropTypes.node,
    message: PropTypes.node
};

export default Panel;
